import { Vector3toV3 as a } from "../index10.js";
function d(e, t) {
  if (!t.length)
    return !1;
  e = a(e), t = t.map(a);
  const h = e[0], c = e[2];
  let i = !1;
  for (let s = 0, r = t.length - 1; s < t.length; r = s++) {
    const f = t[s][0], n = t[s][2], j = t[r][0], x = t[r][2];
    n > c != x > c && h < (j - f) * (c - n) / (x - n) + f && (i = !i);
  }
  return i;
}
export {
  d as isPointInside
};
//# sourceMappingURL=index19.js.map
